<template>
  <button class="theme-toggler" @click="isDark = !isDark">
    <svg
      v-if="!isDark"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-sun"
    >
      <circle cx="12" cy="12" r="5"></circle>
      <line x1="12" y1="1" x2="12" y2="3"></line>
      <line x1="12" y1="21" x2="12" y2="23"></line>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
      <line x1="1" y1="12" x2="3" y2="12"></line>
      <line x1="21" y1="12" x2="23" y2="12"></line>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
    </svg>

    <svg
      v-else
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-moon"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
    </svg>
  </button>
</template>

<script>
import { light, dark } from "../constant/theme";
export default {
  data() {
    return {
      isDark: false,
    };
  },
  watch: {
    isDark(value) {
      this.toggleTheme(value);
    },
  },
  created() {
    const theme = localStorage.getItem("theme");
    if (theme) {
      this.isDark = theme == "dark";
    } else {
      this.isDark = window.matchMedia("(prefers-color-scheme: dark)");
    }
    this.toggleTheme(this.isDark);
  },
  methods: {
    toggleTheme(value) {
      this.$emit("toggle", value);

      const theme = value ? dark : light;
      localStorage.setItem("theme", value ? "dark" : "light");
      document.documentElement.style.setProperty(
        "--background-1",
        theme.background1
      );
      document.documentElement.style.setProperty(
        "--background-2",
        theme.background2
      );
      document.documentElement.style.setProperty(
        "--background-3",
        theme.background3
      );
      document.documentElement.style.setProperty("--dark", theme.dark);
      document.documentElement.style.setProperty("--white", theme.white);
      document.documentElement.style.setProperty("--text", theme.text);
      document.documentElement.style.setProperty("--border", theme.border);
      document.documentElement.style.setProperty(
        "--input-border",
        theme.inputBorder
      );
      document.documentElement.style.setProperty("--input", theme.input);
      document.documentElement.style.setProperty("--gray-1", theme.gray1);
      document.documentElement.style.setProperty("--gray-2", theme.gray2);
      document.documentElement.style.setProperty("--gray-3", theme.gray3);
      document.documentElement.style.setProperty("--gray-4", theme.gray4);
      document.documentElement.style.setProperty("--gray-5", theme.gray5);
    },
  },
};
</script>

<style scoped>
button.theme-toggler {
  position: fixed;
  z-index: 100;
  top: calc(50vh - 20px);
  right: 0px;
  background: rgb(var(--primary));
  border: none;
  padding: 7px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  box-shadow: 0px 4px 25px -4px #6951a4;
}
button.theme-toggler svg {
  color: #fff;
}
</style>